import { useCallback, useState } from 'react';
import TasksService from '../services/TasksService';
import TeamService from '../services/TeamService';
import { errorText } from '../utils/format';
import useAsync from './useAsync';

/** The organization's team with its reporting lines and open-task counts, plus create and edit for owners. */
export function useTeamViewModel() {
  const load = useCallback(async () => {
    const [team, catalog, summary] = await Promise.all([
      TeamService.team(), TeamService.catalog(), TasksService.summary().catch(() => ({ by_bot: {} })),
    ]);
    return { team, catalog, counts: summary.by_bot || {} };
  }, []);
  const { data, loading, error, reload } = useAsync(load);
  const [saving, setSaving] = useState(false);
  const [saveError, setSaveError] = useState('');

  const save = async (fn) => {
    setSaving(true);
    setSaveError('');
    try {
      await fn();
      await reload({ silent: true });
      return true;
    } catch (err) {
      setSaveError(errorText(err));
      return false;
    } finally {
      setSaving(false);
    }
  };

  return {
    team: data?.team || null,
    catalog: data?.catalog || [],
    counts: data?.counts || {},
    loading,
    error,
    reload,
    saving,
    saveError,
    clearSaveError: () => setSaveError(''),
    createBot: (bot) => save(() => TeamService.createBot(data.team.id, bot)),
    updateBot: (id, fields) => save(() => TeamService.updateBot(id, fields)),
    createTeam: (template) => save(() => TeamService.createTeam(template)),
  };
}
